var exports = {
  "TN": "MemberListSkeleton.module__groups___VFlUOW",
  "Os": "MemberListSkeleton.module__group___VFlUOW",
  "Ge": "MemberListSkeleton.module__rows___VFlUOW",
  "x_": "MemberListSkeleton.module__groupHeader___VFlUOW",
  "nM": "MemberListSkeleton.module__row___VFlUOW",
  "u4": "MemberListSkeleton.module__rowContent___VFlUOW",
  "z2": "MemberListSkeleton.module__rowInfo___VFlUOW",
  "U8": "MemberListSkeleton.module__nameSlot___VFlUOW",
  "NJ": "MemberListSkeleton.module__statusSlot___VFlUOW",
};

module.exports = exports;
